import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import Image from "../../elements/image";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, mobileIs } from "../../utils/siteUtils";
import { gtag } from "../../utils";

import './style.scss'
const DriveModels = ({ fields, rendering, page }) => {
    const { title, titleMobile, list, content, contentMobile } = fields; 
		const [activeIndex, setActiveIndex] = useState(-1);
		const [oldActiveIndex, setOldActiveIndex] = useState(-1);
		const isMobile = mobileIs();
    const refs = useRef([]);
		const itemClick = (index) => {
      gtag('event', 'Component_info', {
      'component_name': 'DriveModels',
      'page_title': page?.name
    });
      setOldActiveIndex(activeIndex)
			setActiveIndex(index)
		}
		const itemUnClick = (_) => {
      gtag('event', 'Component_info', {
      'component_name': 'DriveModels',
      'page_title': page?.name
    });
      setOldActiveIndex(activeIndex)
			setActiveIndex(-1)
		}
    
    useEffect(() => {
      if(activeIndex>=0){
        let domHeight = document.getElementById(`content`+activeIndex).clientHeight
        refs.current[activeIndex].style.height = domHeight+'px'
      }
      if(oldActiveIndex>=0){
        refs.current[oldActiveIndex].style.height = '0';
      }
    }, [activeIndex]);
		const rootClasses = classNames("drive-models", getOverallSettingsClasses(fields));
    return (
			<div className={rootClasses} datasourceid={rendering.dataSource}>		
				<RichText className="drive-models-title" field={isMobile ? titleMobile : title}/>	
				<RichText className="drive-models-content" field={isMobile ? contentMobile : content}/>		
				<div className={classNames("drive-models-list",{'three': list.length === 3, 'nocontent': !isMobile && content.value === ''})} >
					{list.length > 0 && 
						list.map((item, index) => {
              let contentId = `content`+index
              return (
                <div className={classNames("drive-models-list-item", {'active': activeIndex === index}, {'marginT': index > 1})} key={index} onMouseOver={ () => itemClick(index)} onMouseLeave={ () => itemUnClick(index)} onClick={ () => itemClick(index)}>
                  <Image className="image" { ... isMobile ? item?.fields?.imageMobile?.value : item?.fields?.image?.value} />
                  <div className="drive-models-list-item-bottom">
                    <div className="circular"></div>
                    <RichText className="title" field={isMobile ? item?.fields?.titleMobile : item?.fields?.title}/>	
                    <div className="content" ref={el => refs.current[index] = el} >
                      <RichText id={contentId} field={isMobile ? item?.fields?.contentMobile : item?.fields?.content}/>
                    </div>
                  </div>
                </div>
              )
            }
						)
					}
				</div>		
			</div>
    )
}
export default DriveModels